var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatastore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 15C14.7202 15 15 14.7202 15 14.375C15 14.0298 14.7202 13.75 14.375 13.75C14.0298 13.75 13.75 14.0298 13.75 14.375C13.75 14.7202 14.0298 15 14.375 15Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.75H5V15H12.5V13.75Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 6.25C14.7202 6.25 15 5.97018 15 5.625C15 5.27982 14.7202 5 14.375 5C14.0298 5 13.75 5.27982 13.75 5.625C13.75 5.97018 14.0298 6.25 14.375 6.25Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5H5V6.25H12.5V5Z",
    fill: "#161616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 8.75C16.5815 8.75 16.8995 8.6183 17.1339 8.38388C17.3683 8.14946 17.5 7.83152 17.5 7.5V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V7.5C2.5 7.83152 2.6317 8.14946 2.86612 8.38388C3.10054 8.6183 3.41848 8.75 3.75 8.75H5V11.25H3.75C3.41848 11.25 3.10054 11.3817 2.86612 11.6161C2.6317 11.8505 2.5 12.1685 2.5 12.5V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V12.5C17.5 12.1685 17.3683 11.8505 17.1339 11.6161C16.8995 11.3817 16.5815 11.25 16.25 11.25H15V8.75H16.25ZM3.75 3.75H16.25V7.5H3.75V3.75ZM16.25 16.25H3.75V12.5H16.25V16.25ZM13.75 11.25H6.25V8.75H13.75V11.25Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatastore);
export default __webpack_public_path__ + "static/media/Datastore.4c882c1b0bd2084ecae181b65bca14fc.svg";
export { ForwardRef as ReactComponent };